import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const TabTwo = () => {
    return (
        <div>
            <div className="row">
                    <div className="col-lg-12">
                        <Tabs>
                            <div className="row row--30 align-items-center">
                                <div className="col-lg-5">
                                    <img className="radius-small" src='./images/tab/tabs-02.jpg' alt="Company information and services overview" />
                                </div>
                                <div className="col-lg-7 mt_md--40 mt_sm--40">
                                    <div className="rn-default-tab style-two">
                                        <div className="tab-button-panel">
                                            <TabList className="tab-button" role="tablist" aria-label="Website section tabs">
                                                <Tab role="tab" aria-selected="false" aria-controls="tab-panel-home">
                                                    <div className="rn-tab-button">
                                                        <button type="button">Home</button>
                                                    </div>   
                                                </Tab>
                                                <Tab role="tab" aria-selected="false" aria-controls="tab-panel-about">
                                                    <div className="rn-tab-button">
                                                        <button type="button">About</button>
                                                    </div>   
                                                </Tab>
                                                <Tab role="tab" aria-selected="false" aria-controls="tab-panel-contact">
                                                    <div className="rn-tab-button">
                                                        <button type="button">Contact</button>
                                                    </div>   
                                                </Tab>
                                            </TabList>
                                        </div>

                                        <div className="tab-content-panel">
                                            <TabPanel role="tabpanel" aria-labelledby="tab-home">
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quibusdam ipsa, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>

                                                        <p>Quibusdam ipsa, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            
                                            <TabPanel role="tabpanel" aria-labelledby="tab-about">
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>Ipsum lorem dolor sit amet consectetur, adipisicing elit. Quibusdam ipsa, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>

                                                        <p>Ipsa Quibusdam, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>

                                            <TabPanel role="tabpanel" aria-labelledby="tab-contact">
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>Exercitationem Ipsum lorem dolor sit amet consectetur, adipisicing elit. Quibusdam ipsa, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla  tempore corrupti! Nemo.</p>

                                                        <p>Ipsa Quibusdam, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tabs>
                    </div>
                </div>
        </div>
    )
}

export default TabTwo
